import { motion } from "framer-motion";

// Scroll-reveal wrapper used across sections
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Overline / eyebrow label
export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs tracking-[0.3em] uppercase font-medium ${
      dark ? "text-champagne" : "text-maroon"
    }`}
  >
    <span className="h-px w-8 bg-champagne inline-block" />
    {children}
  </span>
);
